// Institution slug in the URL - see plan doc. The active institution's slug
// is kept as the router's base path segment (e.g. /greenwood-high/#/home) for
// the whole session. Since the router's base is fixed at page load, actually
// changing it means a full-page reload, not an in-app navigation - these
// helpers centralize that so every caller (post-login, institution switch,
// session-expiry) does it the same way.

import axios from "axios";
import store from "../store";

const ACTIVE_SLUG_STORAGE_KEY = "activeInstitutionSlug";

export function getCachedInstitutionSlug() {
  return localStorage.getItem(ACTIVE_SLUG_STORAGE_KEY);
}

export function setCachedInstitutionSlug(slug) {
  if (slug) {
    localStorage.setItem(ACTIVE_SLUG_STORAGE_KEY, slug);
  } else {
    localStorage.removeItem(ACTIVE_SLUG_STORAGE_KEY);
  }
}

// Current router base, as a bare slug segment (no slashes), or null if the
// app booted from the plain root.
export function getCurrentBaseSlug(router) {
  const match = router.options.base.match(/^\/([a-z0-9-]+)\/$/);
  return match ? match[1] : null;
}

// Hard-navigates to the given institution slug, preserving whatever hash
// route is currently active (falls back to #/home). Full page reload is
// intentional - it's the only way to change the router's base.
export function redirectToInstitutionSlug(slug, fallbackHash = "#/home") {
  setCachedInstitutionSlug(slug);
  const hash = window.location.hash || fallbackHash;
  window.location.href = window.location.origin + "/" + slug + "/" + hash;
}

// Whether the login page should render for the given base slug - true for
// the plain root (slug === null) or a real institution slug (session-expiry
// redirects need those to keep working, see plan doc). Anything else
// (made-up/garbage paths) is rejected.
export async function isLoginSlugAllowed(slug) {
  if (!slug) {
    return true;
  }

  try {
    const url = store.getters.getAPIKey.mainAPI + "/institutions/slug-exists/" + slug;
    const response = await axios.get(url);
    return !!response.data.valid;
  } catch (error) {
    // A network hiccup here shouldn't strand someone on a blocked screen -
    // fail open to the login page rather than closed.
    error;
    return true;
  }
}
